import styled from 'styled-components'

import Alert from '@mui/material/Alert'
import Typography from '@mui/material/Typography'

export const StyledAlert = styled(Alert)`
  display: flex;
  width: 320px;
  padding: 6px 16px;
  align-items: flex-start;
  border-radius: 4px;
  background: var(
    --light-success-shades-190-p,
    linear-gradient(0deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.9) 100%),
    #2e7d32
  );
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);

  // Override the default icon styling
  & .MuiAlert-icon {
    padding: 0;
    margin: 0;
    height: 36px;
  }

  // Override the message styling
  & .MuiAlert-message {
    padding: 0;
    margin: 0;
  }

  // Style the close button
  & .MuiAlert-action {
    padding: 0;
    margin: 0;
    padding-top: 4px;

    & .MuiIconButton-root {
      width: 30px;
      height: 30px;
      border-radius: 100px;
      padding: 5px;
      margin-left: 16px;

      & .MuiSvgIcon-root {
        width: 20px;
        height: 20px;
        font-size: 20px;
      }
    }
  }
`

export const StyledAlertIcon = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 36px;
  padding: 7px 12px 7px 0;
`

export const StyledTitle = styled(Typography)`
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: var(--light-success-shades-160-p, #2e7d32);
`

export const StyledMessage = styled(Typography)`
  padding: 8px 0;
  box-sizing: border-box;
  flex: 1;
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: var(--light-success-shades-160-p, #2e7d32);
`
